export default __webpack_public_path__ + "static/media/easyTen.71901780.png";